export enum InsuranceType {
  GapRtiGross = 'gapRtiGross',
  GapRtiNet50 = 'gapRtiNet50',
  GapRtiNet = 'gapRtiNet',
  OcAcGross = 'ocAcGross',
  OcAcNet50 = 'ocAcNet50',
  OcAcNet = 'ocAcNet'
}
